<template>
  <div>
    <el-card style="min-height: 200px; padding: 20px" v-loading="loading" shadow="never">
      <div v-if="editModel && !errorMsg">
        <el-form
          ref="form"
          :size="$xUISize"
          :model="editModel"
          :rules="editRules"
          @submit.native.prevent
          label-width="auto"
          label-position="top"
        >
          <el-form-item label="中心仓库" prop="storehouseGuid">
            <customer-storehouse-select
              v-model="editModel.storehouseGuid"
              :disabled="true"
            />
          </el-form-item>
          <el-form-item label="调研门店" prop="storeGuidList">
            <customer-store-select v-model="editModel.storeGuidList" :multiple="true" />
          </el-form-item>
          <el-form-item label="调研标题" prop="surveyTitle">
            <el-input
              type="textarea"
              v-model="editModel.surveyTitle"
              :rows="2"
              maxlength="256"
              placeholder="输入调研标题信息"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="调研商品" prop="itemList">
            <div class="hBox" style="padding: 0px">
              <goods-sku-select
                placeholder="从全部商品中选选择"
                :params="goodsSelectParams"
                :showCostPrice="true"
              >
                <template slot="info-append" slot-scope="scope">
                  <div style="margin-top: 10px">
                    <template v-if="getItemBySkuGuid(scope.info.guid)">
                      <el-button
                        size="small"
                        type="danger"
                        v-if="!getItemBySkuGuid(scope.info.guid).guid"
                        @click="removeItemClick(getItemBySkuGuid(scope.info.guid))"
                      >
                        移出
                      </el-button>
                      <el-link
                        v-if="getItemBySkuGuid(scope.info.guid).guid"
                        :type="
                          getItemBySkuGuid(scope.info.guid).isDelete
                            ? 'primary'
                            : 'danger'
                        "
                        :underline="false"
                        @click="deleteClick(getItemBySkuGuid(scope.info.guid))"
                      >
                        {{
                          getItemBySkuGuid(scope.info.guid).isDelete
                            ? "取消删除"
                            : "标记删除"
                        }}
                      </el-link>
                    </template>
                    <template v-else>
                      <el-button
                        size="small"
                        type="primary"
                        @click="handleAddItem(scope.info)"
                      >
                        添加到清单
                      </el-button>
                    </template>
                  </div>
                </template>
              </goods-sku-select>
              <upload-file
                size="small"
                :btnLabel="batchMatchItem ? '批量添加商品' : '上传Excel文件'"
                :fileSize="10240"
                :loading="batchMatchItem"
                :fileTplUrl="'/static/file_tpl/warehouse_survey_item_list_tpl.xls'"
                @handleUploadFile="batchMatchItemClick"
              >
              </upload-file>
            </div>
            <div>
              <el-table
                stripe
                v-if="editModel.itemList && editModel.itemList.length > 0"
                :data="editModel.itemList"
                :cell-class-name="delLine"
                :size="$xUISize"
                style="width: 100%; margin-top: 10px"
              >
                <el-table-column label="商品信息" min-width="380px">
                  <template slot-scope="scope">
                    <div style="margin-right: 10px">
                      <goods-sku-info :skuInfo="scope.row.skuInfo" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="120px">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="danger"
                      v-if="!scope.row.guid"
                      @click="removeItemClick(scope.row)"
                    >
                      移出
                    </el-button>
                    <el-link
                      v-if="scope.row.guid"
                      :type="scope.row.isDelete ? 'primary' : 'danger'"
                      :underline="false"
                      @click="deleteClick(scope.row)"
                    >
                      {{ scope.row.isDelete ? "取消删除" : "标记删除" }}
                    </el-link>
                  </template>
                </el-table-column>
              </el-table>
              <div
                style="color: #999999; font-size: 14px; margin-top: 20px"
                v-if="editModel.itemList && editModel.itemList.length > 0"
              >
                <span>合计：共</span>
                <span style="color: #f56c6c">
                  {{ (editModel.itemList && editModel.itemList.length) || 0 }}
                </span>
                <span>种</span>
              </div>
              <div v-else style="color: #999999; font-size: 14px; margin-top: 20px">
                * 请选择商品添加到清单
              </div>
            </div>
          </el-form-item>
          <el-form-item label="备注说明" prop="optRemark">
            <el-input
              type="textarea"
              v-model="editModel.optRemark"
              :rows="3"
              maxlength="256"
              placeholder="输入备注说明内容"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="editSubmit"
              :disabled="
                editSubmit || !editModel.itemList || editModel.itemList.length <= 0
              "
              @click="submitClick"
            >
              提交
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-empty
        v-else-if="!loading && errorMsg"
        :description="errorMsg"
        :image-size="100"
      >
        <el-button v-if="errorMsg" @click="fetchModel" size="small"> 重新加载 </el-button>
      </el-empty>
    </el-card>
  </div>
</template>

<script>
import uploadFile from "../../../../components/uploadFile.vue";
import goodsSkuInfo from "../../../../components/business/goodsSkuInfo.vue";
import goodsSkuSelect from "../../../../components/business/goodsSkuSelect.vue";
import goodsSkuSupplierSelect from "../../../../components/business/goodsSkuSupplierSelect.vue";
import customerStoreSelect from "../../../../components/business/customerStoreSelect.vue";
import customerStorehouseSelect from "../../../../components/business/customerStorehouseSelect.vue";
import customerStoreSupplierSelect from "../../../../components/business/customerStoreSupplierSelect.vue";
import warehouseReplenishSelect from "../../../../components/business/warehouseReplenishSelect.vue";

const defaultModel = {
  itemList: [],
  surveyTitle: "",
  storeGuidList: "",
};

export default {
  components: {
    uploadFile,
    goodsSkuInfo,
    goodsSkuSelect,
    goodsSkuSupplierSelect,
    customerStoreSelect,
    customerStorehouseSelect,
    customerStoreSupplierSelect,
    warehouseReplenishSelect,
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    goodsSelectParams() {
      return {
        optSplit: 0,
      };
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      batchMatchItem: false,
      editSubmit: false,
      editModel: null,
      editRules: {
        storehouseGuid: [
          {
            required: true,
            message: "中心仓库不能为空",
            trigger: "change",
          },
        ],
        surveyTitle: [
          {
            required: true,
            message: "调研标题不能为空",
            trigger: "change",
          },
        ],
        storeGuidList: [
          {
            required: true,
            message: "调研门店不能为空",
            trigger: "change",
          },
        ],
        itemList: [
          {
            validator: (rule, value, callback) => {
              callback();
            },
            required: true,
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    delLine({ row, column, rowIndex, columnIndex }) {
      if (row.isDelete) return "del_line";
    },
    validate() {
      if (this.$refs.form) {
        this.$refs.form.validate();
      }
    },
    batchMatchItemClick(fileData) {
      if (this.batchMatchItem) {
        return;
      }
      this.batchMatchItem = true;
      this.requestApi(
        "biz.warehouse.survey.info.batchMatchItem",
        {
          excelBase64: fileData.data,
        },
        {
          timeout: 1000 * 60 * 60 * 24,
          showError: true,
        }
      )
        .then((resp) => {
          this.success("提交成功");
          console.log(resp);
          if (!this.editModel.itemList) {
            this.editModel.itemList = [];
          }
          (resp.data || []).forEach((iitem) => {
            let skuInfo = iitem.skuInfo;
            let flag = false;
            this.editModel.itemList.forEach((i) => {
              if (i.skuGuid == skuInfo.guid) {
                flag = true;
              }
            });
            if (!flag) {
              this.editModel.itemList.unshift({
                skuInfo: skuInfo,
                skuGuid: skuInfo.guid,
                isDelete: 0,
              });
            }
          });
          this.validate();
        })
        .finally(() => {
          this.batchMatchItem = false;
        });
    },
    getItemBySkuGuid(skuGuid) {
      let findItem;
      (this.editModel.itemList || []).forEach((item) => {
        if (item.skuGuid == skuGuid) {
          findItem = item;
        }
      });
      return findItem;
    },
    removeItemClick(row) {
      if (!this.editModel.itemList) {
        this.editModel.itemList = [];
      }
      let indexOf = -1;
      this.editModel.itemList.forEach((i, index) => {
        if (row.skuGuid == i.skuGuid) {
          indexOf = index;
        }
      });
      if (indexOf >= 0) {
        this.editModel.itemList.splice(indexOf, 1);
      }
    },
    deleteClick(item) {
      item.isDelete = item.isDelete ? 0 : 1;
    },
    handleAddItem(item) {
      if (!this.editModel.itemList) {
        this.editModel.itemList = [];
      }
      let flag = false;
      this.editModel.itemList.forEach((i) => {
        if (i.skuGuid == item.guid) {
          flag = true;
        }
      });
      if (!flag) {
        this.editModel.itemList.unshift({
          skuInfo: item,
          skuGuid: item.guid,
          isDelete: 0,
        });
      }
      this.validate();
    },
    checkItemList() {
      let flag = true;
      this.editModel.itemList.forEach((i) => {
        if (!i.isDelete && i.goodsCount < 0) {
          flag = false;
        }
      });
      if (!flag) {
        this.error("清单列表数量不能小于0");
      }
      return flag;
    },
    submitClick() {
      if (!this.checkItemList()) {
        return;
      }
      this.$refs.form.validate((valid, data) => {
        if (valid) {
          this.editSubmit = true;
          let method = "biz.warehouse.survey.info.createBatch";
          this.requestApi(
            method,
            {
              storehouseGuid: this.editModel.storehouseGuid,
              storeGuidList: this.editModel.storeGuidList,
              createParam: this.editModel,
            },
            {
              showError: true,
            }
          )
            .then((resp) => {
              this.success("提交成功");
              this.$drawer.refreshDrawer();
              this.$drawer.backDrawer();
            })
            .finally(() => {
              this.editSubmit = false;
            });
        } else {
          this.showValidate(data);
        }
      });
    },
    handleModel() {
      // nothing
      if (this.pageParams.copyGuid) {
        this.editModel.copyGuid = this.pageParams.copyGuid;
      }
      if (this.pageParams.storehouseGuid) {
        this.editModel.storehouseGuid = this.pageParams.storehouseGuid;
      }
      this.fetchCopyModel();
    },
    fetchModel() {
      // 新增
      this.editModel = Object.assign({}, defaultModel, {
        itemList: [],
      });
      this.handleModel();
    },
    fetchCopyModel() {
      if (this.editModel.copyGuid) {
        this.loading = true;
        this.errorMsg = null;
        this.requestApi("biz.warehouse.survey.info.detail", {
          guid: this.editModel.copyGuid,
        })
          .then((resp) => {
            return this.requestApi("biz.warehouse.survey.item.list", {
              purchaseGuid: resp.data.guid,
            }).then((listResp) => {
              this.editModel.surveyTitle = resp.data.surveyTitle;
              this.editModel.itemList = (listResp.data.list || []).map((item) => {
                return {
                  skuInfo: item.skuInfo,
                  skuGuid: item.skuGuid,
                  isDelete: 0,
                };
              });
            });
          })
          .catch((err) => {
            let errorMessage = (err && err.msg) || (err && err.message) || "数据加载失败";
            this.$confirm(errorMessage, "重试", {
              type: "info",
            })
              .then(() => {
                this.fetchCopyModel();
              })
              .catch((_) => {
                this.$drawer.backDrawer();
              });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
  created() {
    this.fetchModel();
  },
};
</script>
